<div class="recover-wrap">
  <div class="recover-card">

    <div class="recover-title">RECUPERACIÓN DE PIN</div>
    <div class="recover-subtitle">ESCRIBE TU NUEVO PIN Y CONFÍRMALO</div>

    <!-- PIN NUEVO -->
    <div class="otp-block">
      <div class="otp-label">PIN NUEVO (6 DÍGITOS)</div>
      <div class="otp-grid">
        <input
          #newPinDigit
          *ngFor="let _ of pinDigits; let i = index"
          class="otp-input"
          type="password"
          maxlength="1"
          inputmode="numeric"
          [value]="newPinOtp[i]"
          (input)="onOtpInput($event, i, 'new')"
          (keydown)="onOtpKeyDown($event, i, 'new')"
          (paste)="onOtpPaste($event, 'new')"
        />
      </div>
    </div>

    <!-- CONFIRMAR -->
    <div class="otp-block">
      <div class="otp-label">CONFIRMAR PIN NUEVO (6 DÍGITOS)</div>
      <div class="otp-grid">
        <input
          #confirmPinDigit
          *ngFor="let _ of pinDigits; let i = index"
          class="otp-input"
          type="password"
          maxlength="1"
          inputmode="numeric"
          [value]="confirmOtp[i]"
          (input)="onOtpInput($event, i, 'confirm')"
          (keydown)="onOtpKeyDown($event, i, 'confirm')"
          (paste)="onOtpPaste($event, 'confirm')"
        />
      </div>
    </div>

    <!-- LEYENDA EN VIVO -->
    <div
      class="otp-live-hint"
      [class.otp-live-hint--success]="isNewPinLiveSuccess"
    >
      {{ newPinLiveMessage }}
    </div>

    <div
      class="otp-error"
      *ngIf="form.hasError('pinMismatch') && (form.get('confirmNewPin')?.value?.length === 6)">
      EL PIN NUEVO Y SU CONFIRMACIÓN NO COINCIDEN.
    </div>

    <div class="recover-btn-wrap">
      <button
        mat-flat-button
        color="primary"
        class="recover-btn"
        type="button"
        (click)="submit()"
        [disabled]="saving">
        GUARDAR PIN
      </button>
    </div>

  </div>

  <!-- MODAL ERROR PIN -->
  <div class="rmd-modal-backdrop" *ngIf="showPinErrorModal">
    <div class="rmd-modal-card">
      <div class="rmd-modal-header">
        <div class="rmd-modal-icon-wrap">
          <span class="rmd-modal-icon">!</span>
        </div>
      </div>

      <div class="rmd-modal-body">
        <div class="rmd-modal-title">{{ pinErrorModalTitle }}</div>

        <div class="rmd-modal-divider"></div>

        <div class="rmd-modal-message">
          {{ pinErrorModalMessage }}
        </div>

        <div class="rmd-modal-note">
          REVISA TU PIN Y VUELVE A INTENTAR.
        </div>
      </div>

      <div class="rmd-modal-footer">
        <button
          type="button"
          class="rmd-modal-btn"
          (click)="closePinErrorModal()">
          ENTENDIDO
        </button>
      </div>
    </div>
  </div>
</div>
